import Cookies from 'js-cookies'

const Lang = 'Lang'
const Folio = 'Folio'

/**
 * @method setLang
 * @param {String} lang
 * @returns {String}
 */

export function setLang(lang) {
  return Cookies.setItem(Lang, lang)
}

/**
 * @method getLang
 * @returns {String | Undefined}
 */

export function getLang() {
  return Cookies.getItem(Lang)
}

/**
 * @method setFolio
 * @param {String} folio
 * @returns {String}
 */

export function setFolio(folio) {
  return Cookies.setItem(Folio, folio)
}

/**
 * @method getFolio
 * @returns {String | Undefined}
 */

export function getFolio() {
  return Cookies.getItem(Folio)
}

/**
 * @method removeFolio
 * @returns {Undefined}
 */

export function removeFolio() {
  return Cookies.removeItem(Folio)
}
